import {Component, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaDialog} from '../dialog/dialog';
import {UnsavedChangesService} from '../../services/unsaved-changes.service';

@Component({
  selector: 'elcia-unsaved-changes-dialog',
  imports: [ElciaDialog, TranslatePipe],
  templateUrl: './unsaved-changes-dialog.html',
})
export class UnsavedChangesDialog {
  protected readonly unsavedChangesService = inject(UnsavedChangesService);
}
